module.exports = __webpack_public_path__ + "img/smile_active.d0279371.svg";